module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/download-c7ed5a2f143aa3204da28007b97e2f8b.svg";